module.exports = __webpack_public_path__ + "img/resource.868ee7d8.svg";